<div class="main" *ngIf="dataSource && dataSource.length">
    <div class="section">
        <div class="header">
            <div class="label">{{title}} - {{dataSource.length}}</div>
            <div class="icons">
                <div class="icon" *ngIf="!mapView">
                    <i class="material-icons" (click)="openShipments();">open_in_new</i>
                </div>
                <div class="icon">
                    <i class="material-icons" (click)="dialog.close();">clear</i>
                </div>
            </div>
        </div>
        <div class="map" *ngIf="mapView">
            <div class="toggleButton" (click)="showMap = !showMap;">
                <div class="but">
                    <div class="label" *ngIf="!showMap" (click)="initMap()">Map View</div>
                    <div class="label" *ngIf="showMap" (click)="removeMarkers()">Table View</div>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="table" *ngIf="dataSource && dataSource.length && !showMap">
                <table mat-table *ngIf="dataSource && dataSource.length" [dataSource]="dataSource"
                    class="mat-elevation-z8">
                    <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
                        <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                        <td mat-cell *matCellDef="let element">
                            <span *ngIf="column !== 'SIN'&& column !== 'Last GPS Pinged'"> {{element[column]}} </span>
                            <a [ngStyle]="{'color': '#2862FF', 'text-decoration': 'none'}" *ngIf="column === 'SIN'"
                                [href]="element.tracker" target="_blank">{{element[column]}}</a>
                            <a [ngStyle]="{'color': '#2862FF', 'text-decoration': 'none'}"
                                *ngIf="column === 'Last GPS Pinged'" (click)="openCustomerMap(element.coordinates)"
                                target="_blank">{{element[column]}}</a>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <div class="maps" id="mapId"></div>
        </div>
    </div>
</div>